/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import LengthIcon from '../../../../components/icons/length-icon.svg';
import WidthIcon from '../../../../components/icons/width-icon.svg';
import HeightIcon from '../../../../components/icons/height-icon.svg';
import { SizeTextIcon } from '../../../../components/text-icon';

const IcepackCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'sizes') {
		return (
			<div className="icepack-custom-modal-cell__sizes">
				<Popup
					content={
						<p>
							<b>Длина:</b> {`${rowData.value.length} см`}
						</p>
					}
					trigger={
						<div className="icepack-custom-modal-cell__sizes-unit">
							<img
								className="icepack-custom-modal-cell__sizes-image"
								src={LengthIcon}
								alt="length-icon"
							/>
							<div className="icepack-custom-modal-cell__sizes-field">{rowData.value.length}</div>
							{SizeTextIcon}
						</div>
					}
					position="top center"
					size="mini"
					inverted
					style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
				/>
				<Popup
					content={
						<p>
							<b>Ширина:</b> {`${rowData.value.width} см`}
						</p>
					}
					trigger={
						<div className="icepack-custom-modal-cell__sizes-unit">
							<img className="icepack-custom-modal-cell__sizes-image" src={WidthIcon} alt="width-icon" />
							<div className="icepack-custom-modal-cell__sizes-field">{rowData.value.width}</div>
							{SizeTextIcon}
						</div>
					}
					position="top center"
					size="mini"
					inverted
					style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
				/>
				<Popup
					content={
						<p>
							<b>Высота:</b> {`${rowData.value.height} см`}
						</p>
					}
					trigger={
						<div className="icepack-custom-modal-cell__sizes-unit">
							<img
								className="icepack-custom-modal-cell__sizes-image"
								src={HeightIcon}
								alt="height-icon"
							/>
							<div className="icepack-custom-modal-cell__sizes-field">{rowData.value.height}</div>
							{SizeTextIcon}
						</div>
					}
					position="top center"
					size="mini"
					inverted
					style={{ textAlign: 'center', fontSize: 12, fontWeight: '500' }}
				/>
			</div>
		);
	}

	if (rowData.id === 'author') {
		return (
			<span className="icepack-custom-modal-cell__author">
				<b>{rowData.value.name}</b>
				<small>
					<i>{rowData.value.role}</i>
				</small>
			</span>
		);
	}

	return rowData.value;
};

IcepackCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { IcepackCustomModalCell };
